import { WALLET_RATES } from "@/pages/retailer/wallet/constants";
import { formatINR } from "@/pages/retailer/wallet/data";

export default function ChargesCard({
  available,
  creationCharge = WALLET_RATES.CREATION_CHARGE,
}: {
  available: number;
  creationCharge?: number;
}) {
  const total = creationCharge;
  const low = available < total;

  return (
    <div className="w-full rounded-lg border border-line bg-[#F8FAFC] p-4 lg:w-[280px]">
      <p className="text-sm font-semibold text-ink">Charges</p>
      <dl className="mt-3 flex flex-col gap-2.5">
        <div className="flex items-center justify-between">
          <dt className="text-[13px] text-ink-secondary">Mandate creation charge</dt>
          <dd className="text-[13px] font-medium text-ink">{formatINR(total)}</dd>
        </div>
      </dl>

      <div className="my-3 h-px bg-line" />
      <div className="flex items-center justify-between">
        <span className="text-sm font-semibold text-ink">Total charge</span>
        <span className="text-sm font-semibold text-ink">{formatINR(total)}</span>
      </div>
      <p className="mt-2 text-xs text-ink-secondary">
        This charge is not refundable if the mandate is not authorised.
      </p>

      <div className="my-3 h-px bg-line" />
      <div className="flex items-center justify-between">
        <span className="text-[13px] text-ink-secondary">Available balance</span>
        <span className={`text-sm font-semibold ${low ? "text-danger" : "text-ink"}`}>{formatINR(available)}</span>
      </div>
    </div>
  );
}